import React, { Component } from 'react';
import './content.css';
import {Spring} from 'react-spring/renderprops';

export default class Content extends Component {
    render() {
        return (
            <Spring
            config={{tension: 280, friction: 60, delay: 2000, duration:3000 }}
            from={{opacity:0}}
            to={{opacity:1}}
            >
                { props => (
                    <div style={props}>
                        <div>
                            <h1 className='titulo'>Resistência elétrica</h1>
                            <p>
                                &nbsp; &nbsp; &nbsp;Resistência elétrica é a capacidade de um corpo qualquer se opor à passagem de corrente elétrica mesmo quando existe uma diferença de potencial aplicada. Seu cálculo é dado pela Primeira Lei de Ohm, e, segundo o Sistema Internacional de Unidades (SI), é medida em ohms.
                            </p>
                            <p>
                                Os fatores que influenciam na resistência de um dado condutor são:
                            </p>
                            <ul>
                                <li>A resistência de um condutor é tanto maior quanto maior for seu comprimento.</li>
                                <li>A resistência de um condutor é tanto maior quanto menor for a área de sua seção transversal, isto é, quanto mais fino for o condutor.</li>
                                <li>A resistência de um condutor depende da resistividade do material de que ele é feito. A resistividade, por sua vez, depende da temperatura na qual o condutor se encontra.</li>
                            </ul>
                            <h2 className='subtitulo'>
                                Associação de resistências em Série
                            </h2>
                            <p>
                                &nbsp; &nbsp; &nbsp;A característica tensão-corrente de um sistema de várias resistências tem sempre o mesmo aspecto que a caraterística de uma única resistência; nomeadamente, é uma reta que passa pela origem. O declive dessa reta é a resistência equivalente. Podemos usar algumas regras simples para calcular a resistência equivalente, quando as resistências estiverem ligadas em série ou em paralelo.
                            </p>
                            <p>
                            Duas resistências estarão ligadas em série, quando uma estiver a seguir à outra, sem nenhum outro elemento de circuito no meio, como se mostra na figura abaixo:
                            </p>
                            <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Associa%C3%A7%C3%A3o_de_resistencia.svg/370px-Associa%C3%A7%C3%A3o_de_resistencia.svg.png' className="center" alt="Resistors em Serie"/>
                            <img src='https://wikimedia.org/api/rest_v1/media/math/render/svg/bd031d9c6b3603022c85987a2d9d17b3a4775350' className="center3" alt="Formula Resistors em Serie"/>
                            <p>
                                Num sistema de duas resistências ligadas em série, a corrente é a mesma nas duas resistências. A diferença de potencial no sistema é a soma das diferenças de potencial em cada resistência.
                            </p>
                            <h2 className='subtitulo'>
                                Associação em Paralelo
                            </h2>
                            <p>
                                Diz-se que duas resistências estão ligadas em paralelo , se os dois terminais de cada uma das resistências estiverem ligados entre os mesmos pontos, como mostra a figura a seguir:
                            </p>
                            <img src='https://3.bp.blogspot.com/-Q3EK4ycLQwQ/U2Ml3TzlUcI/AAAAAAAAJkQ/EmqwCpY4xrE/s1600/resistores+em+paralelo.png' className="center4" alt="Resistors em Paralelo"/>
                            <p>
                                &nbsp; &nbsp; &nbsp;Num sistema de duas resistências ligadas em paralelo, a diferença de potencial é a mesma nas duas resistências. A corrente no sistema é a soma das correntes em cada resistência.
                            </p>
                            <p>
                                A Resistência Equivalente com dois resistores de valores diferentes pode ser definido da seguinte forma:
                            </p>
                            <img src='https://wikimedia.org/api/rest_v1/media/math/render/svg/678d14cb4347234053b00c01e0e45c29b1e8a624' className="center2" alt="Formula Resistors em Paralelo"/>
                        </div>
                    </div>
                    )}
            </Spring>
        )
    }
}